import React from "react";
import { TrendingDown, TrendingUp, Minus } from "lucide-react";
import {
  formatPnlCoin,
  formatPnlPercent,
  getPnlCopy,
  getPnlNeedlePct,
} from "../../utils/casinoHelpers";

const BondSpinTablePnl = ({ pnl, isMine = false, compact = false }) => {
  if (!pnl?.available) return null;

  const tone = pnl.tone || "flat";
  const needlePct = getPnlNeedlePct(pnl.pct);
  const fillWidth =
    tone === "up" ? Math.max(2, needlePct - 50) : tone === "down" ? Math.max(2, 50 - needlePct) : 0;

  return (
    <div className={`bspin-pnl bspin-pnl-${tone}${compact ? " compact" : ""}`}>
      {!compact ? (
        <p className="bspin-pnl-copy">{getPnlCopy(tone, isMine)}</p>
      ) : null}

      <div className="bspin-pnl-meter" aria-hidden>
        <span className="bspin-pnl-lane loss" />
        <span className="bspin-pnl-lane gain" />
        <span className="bspin-pnl-mid" />
        {tone === "down" ? (
          <span className="bspin-pnl-fill loss" style={{ width: `${fillWidth}%` }} />
        ) : null}
        {tone === "up" ? (
          <span className="bspin-pnl-fill gain" style={{ width: `${fillWidth}%` }} />
        ) : null}
        <span className="bspin-pnl-needle" style={{ left: `${needlePct}%` }} />
      </div>

      <div className="bspin-pnl-meta">
        <span>Opened {formatPnlCoin(pnl.opened).replace("+", "")}</span>
        {pnl.houseTake > 0 ? (
          <span className="bspin-pnl-taken">Taken {formatPnlCoin(pnl.houseTake).replace("+", "")}</span>
        ) : (
          <span>Now {formatPnlCoin(pnl.current).replace("+", "")}</span>
        )}
      </div>
    </div>
  );
};

export const BondSpinPnlStamp = ({ pnl }) => {
  if (!pnl?.available) return null;
  const tone = pnl.tone || "flat";
  const Icon = tone === "up" ? TrendingUp : tone === "down" ? TrendingDown : Minus;

  return (
    <span className={`bspin-pnl-stamp bspin-pnl-stamp-${tone}`}>
      <Icon size={11} strokeWidth={2.6} />
      <strong>{formatPnlPercent(pnl.pct)}</strong>
      <em>{formatPnlCoin(pnl.delta)}</em>
    </span>
  );
};

export default BondSpinTablePnl;
